export const environment = {
  production: false,
 //apiUrl: 'http://localhost:8089'
  //apiUrl: 'https://beekidsback-multietablissement.dpc.com.tn'
  //apiUrl:'https://beekids.back.multietablissemnt.preprod.dpc.com.tn'
  apiUrl: 'https://beekistest.dpc.com.tn'

};
